'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');let

TermsConfig=function(){_createClass(TermsConfig,null,[{key:'$inject',get:function()
{return['$stateProvider']}}]);

function TermsConfig($stateProvider){_classCallCheck(this,TermsConfig);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('terms');
$stateProvider.state(feature.fullName,feature.config);
}return TermsConfig}();


module.exports=TermsConfig;
//# sourceMappingURL=termsConfig.js.map
